"use strict";

var isValue = require("../is-value");

var keys = Object.keys;

module.exports = function (object) {
	return keys(isValue(object) ? Object(object) : object);
};



// WEBPACK FOOTER //
// ./node_modules/event-emitter/node_modules/es5-ext/object/keys/shim.js